import React from 'react'
import { Alcance } from '../Alcance';
import DatePicker from 'react-datepicker';
import { guardarMeasure } from '../firebase';
import { yearMeasure } from '../pages/Home';

function MedirTransporteMaritimo ( props ) {
    const sub = props.sub

    //const [startDate, setStartDate] = React.useState(new Date());
    const [nombreEntrada, setNombreEntrada] = React.useState('Transporte materia prima');
    const [origen, setOrigen] = React.useState('');
    const [destino, setDestino] = React.useState('');
    //const [trayecto, setTrayecto] = React.useState('');
    const [kilometros, setKilometros] = React.useState('');
    const [tipoVehiculo, setTipoVehiculo] = React.useState('');
    const [marcaReferencia, setMarcaReferencia] = React.useState('');
    const [unidadesTransportadas, setUnidadesTransportadas] = React.useState(1);
    const [peso, setPeso] = React.useState(0);
    const [alcance, setAlcance] = React.useState(1);
    const [classValida, setClassValida] = React.useState('class__valida__red');
    const [isCargado, setIsCargado] = React.useState(false);

      const handleNombreEntrada = (event) => {
        
        setNombreEntrada(event.target.value);
        console.log('NombreEntrada: '+nombreEntrada);
      }
      const onClickSelectNombre =(event)=>{
        setClassValida('class__valida__green')
        setNombreEntrada(event.target.value);
      }
      const handleOrigen = (event) => {
        setOrigen(event.target.value);
        //setTrayecto(event.target.value +' - '+ destino +' - '+ event.target.value)
      }
      
      const handleDestino = (event) => {
        setDestino(event.target.value);
        //setTrayecto(origen +' - '+ event.target.value +' - '+ origen)
      }
      /*const handleTrayecto = (event) => {
          setTrayecto(event.target.value)
      }*/
      const handleTipoVehiculo = (event) => {
        
        setTipoVehiculo(event.target.value);
      }
      /*const handleKilometros = (event) => {
        console.log('kilometros: '+kilometros);
        setKilometros(event.target.value);
      }
      const handleMarcaReferencia = (event) => {
        console.log('marcaReferencia: '+marcaReferencia);
        setMarcaReferencia(event.target.value);
      }
      const handleUnidadesTransportadas = (event) => {
        console.log('UnidadesTransportadas: '+unidadesTransportadas);
        setUnidadesTransportadas(event.target.value);
      }
      const handlePeso = (event) => {
        console.log('cPeso: '+peso);
        setPeso(event.target.value);
      }*/
      const handleAlcance = (event) => {
        setAlcance(event.target.value);
        
      }

      const onSubmit = async (event) => {
        event.preventDefault();
          const fecha_modificacion = new Date().toUTCString();
          let resultado_gco2 = kilometros * peso * sub.fe;
          let resultado_kgco2 = resultado_gco2 / 1000;
          let measure = {
            alcance: Number(alcance),
            categoria: sub.nombre,
            destino: destino,
            distancia_km: Number(kilometros),
            empresa: 'Fibtex',
            fe: sub.fe,
            nombre: nombreEntrada,
            origen: origen,
            //trayecto: trayecto,
            peso_ton: Number(peso),
            referencia_producto: marcaReferencia,
            resultado_gco2: resultado_gco2,
            resultado_kgco2: resultado_kgco2,
            unidades_transportadas: unidadesTransportadas,
            subcategoria: sub.nombre,
            tipo_vehiculo: tipoVehiculo,
            user_email: props.user.email,
            fecha_modificacion: fecha_modificacion,
            year: yearMeasure
          }

          enviarGuardado(measure)
      }
    const cerrarInfo=()=>{
      setIsCargado(false);
    }
    const enviarGuardado = async (measure) =>{
        const result = await guardarMeasure(measure);
        if (result) {
            console.log(result);
            
            setDestino('');
            //setTrayecto('');
            setKilometros('');
            setMarcaReferencia('');
            setUnidadesTransportadas('');
            setPeso('');

            setIsCargado(true);
            
        }else{
          alert('Ocurrió un error inesperado, por favor refresque la página e intente de nuevo.')
      }
    }
      
  return (
    
        <div >
          { isCargado &&
              <div className='entrada__ingresada'>
                <div className='items__ingresada'>
                  <h4 style={{background:'transparent'}}  >Registro ingresado correctamente</h4>
                  <button className='items__ingresado__button' onClick={cerrarInfo}>Aceptar</button>
                </div>
              </div>
            }
          <h2 style={{ whiteSpace:'pre-line', textAlign:'center'}}>Subcategoría transporte marítima</h2>
            <form onSubmit={onSubmit}>
                <div className="form-group">
                  <label>Nombre subcategoría</label>
                    <select id='selectNombre' className={classValida} style={{ borderRadius:'1.25rem',width:'100%',display:'block',padding:'0.375rem 0.75rem'}}  
                        value={nombreEntrada} 
                        onChange={handleNombreEntrada}
                        onClick={onClickSelectNombre}>
                        <option value='Transporte materia prima' >Transporte materia prima</option>
                        <option value='Transporte producto final' >Transporte producto final</option>
                        <option value='Transporte producto final' >Transporte reciclaje</option>
                    </select>
                </div>
                
                <div className='form-group'>
                    <label>Alcance</label>
                    <Alcance name="alcance" value={alcance} onChange={handleAlcance}></Alcance>
                </div>
                <div className='form-group'>
                    <label>Año seleccionado</label>
                    <label className='year__seleccionado' value={yearMeasure} >{yearMeasure}</label>
                </div>
                {/*<div className="form-group" >
                    <label>Fecha</label>
                    <DatePicker className='datePicker__input' 
                        selected={startDate}
                        onChange={(date) => setStartDate(date)}
                    />
                    <label>Este es un viaje periódico</label>
                </div>*/}
                <div className="form-group">
                    <label>Origen</label>
                    <input 
                      required type="text" 
                      className="form-control" 
                      value={origen} 
                      onChange={handleOrigen}
                      onInvalid={(e) => e.target.setCustomValidity('Por favor ingrese una ciudad de origen!')}
                      onInput={(e) => e.target.setCustomValidity('')}
                      placeholder="Origen"
                    />
                </div>
                <div className="form-group">
                    <label>Destino</label>
                    <input 
                      required type="text" 
                      className="form-control" 
                      value={destino} 
                      onChange={handleDestino} 
                      placeholder="Destino" 
                      onInvalid={(e) => e.target.setCustomValidity('Por favor ingrese una ciudad de destino!')}
                      onInput={(e) => e.target.setCustomValidity('')}
                    />
                </div>
                {/*<div className="form-group">
                    <label>Trayecto completo</label>
                    <input type="text" className="form-control" value={trayecto} onChange={handleTrayecto} placeholder="Trayecto" />
                </div>*/}
                <div className="form-group">
                  <label>Distancia (km)</label>
                  <input 
                  required type="number" step='0.01' 
                  className="form-control"
                  value={kilometros} 
                  onChange={e => setKilometros(e.target.value)} 
                  placeholder="Distancia en km"
                  onInvalid={(e) => e.target.setCustomValidity('Por favor ingrese una distancia en kilómetros!')}
                  onInput={(e) => e.target.setCustomValidity('')}
                  style={{ width:'25%'}}/>
                </div>
                <div className="form-group">
                  <label>Referencia o tipo producto</label>
                  <input type="text" className="form-control" value={marcaReferencia} onChange={e => setMarcaReferencia(e.target.value)} placeholder="Marca o referencia producto" />
                </div>
                <div className="form-group" id='peso_div'>
                  <label>Peso (Toneladas)</label>
                  <input 
                    required type="number" step='0.01'
                    className="form-control" 
                    value={peso} 
                    onChange={e => setPeso(e.target.value)} 
                    placeholder="Toneladas"
                    onInvalid={(e) => e.target.setCustomValidity('Por favor ingrese un peso en toneladas!')}
                    onInput={(e) => e.target.setCustomValidity('')}
                    style={{ width:'25%'}}/>
                </div>
                <div className="form-group">
                  <label>Unidades transportadas</label>
                  <input 
                    required type="number" 
                    className="form-control" 
                    value={unidadesTransportadas} 
                    onChange={e => setUnidadesTransportadas(e.target.value)} 
                    placeholder="Unidades transportadas"
                    onInvalid={(e) => e.target.setCustomValidity('Por favor ingrese cantidad de unidades!')}
                    onInput={(e) => e.target.setCustomValidity('')} 
                    style={{ width:'25%'}}
                  />
                </div>
            
                <label>Tipo de embarcación</label>
                <input 
                  required type="text" 
                  className="form-control" 
                  value={tipoVehiculo} 
                  onChange={handleTipoVehiculo}
                  onInvalid={(e) => e.target.setCustomValidity('Por favor ingrese tipo de embarcación!')}
                  onInput={(e) => e.target.setCustomValidity('')}
                  placeholder="Tipo barco" 
                />
                <button className='boton__agregar__entrada'>Agregar nueva entrada</button>
            </form>
        </div>
  )
}

export { MedirTransporteMaritimo }
